import React from "react";
import { Link } from "react-router-dom";
import { useSiteData } from "../lib/hooks";
import { fileUrl } from "../lib/api";
import { Reveal, Overline } from "../components/site/Reveal";
import PageHeader from "../components/site/PageHeader";
import { ArrowRight } from "lucide-react";

const IMG = (s, k) => fileUrl(s?.images?.[k]);

export default function About() {
  const s = useSiteData();
  return (
    <div>
      <PageHeader overline="Our Story" title={<>The house of <span className="italic gold-text">Offering Flavours.</span></>}
        subtitle="A premium Indian catering house built on craft, hospitality and flawless execution." image={IMG(s, "chef")} />

      <section className="py-24 sm:py-32 bg-ivory">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
          <Reveal>
            <Overline>Who We Are</Overline>
            <h2 className="font-serif text-burgundy text-4xl sm:text-5xl mt-5 mb-6 leading-tight">Food is the centre of every gathering.</h2>
            <p className="text-charcoal/70 leading-relaxed mb-4">
              Foodie Connect Caterer is a professional non-vegetarian catering and food-service company.
              We bring together thoughtfully crafted food, professional hospitality and seamless execution to
              create experiences people remember.
            </p>
            <p className="text-charcoal/60 leading-relaxed">
              From weddings and private celebrations to corporate programmes, conferences, bulk food requirements
              and recurring meal services — we scale gracefully without ever compromising on flavour or finesse.
            </p>
          </Reveal>
          <div className="relative h-[520px]">
            <Reveal className="absolute left-0 top-0 w-[60%] h-[80%]"><div className="w-full h-full frame-arch border border-gold/30 overflow-hidden group shadow-2xl"><img src={IMG(s, "tandoori")} alt="Tandoori" className="w-full h-full object-cover img-zoom" /></div></Reveal>
            <Reveal delay={0.2} className="absolute right-0 bottom-0 w-[48%] aspect-square"><div className="w-full h-full frame-oval border-2 border-gold/40 overflow-hidden shadow-2xl"><img src={IMG(s, "biryani2")} alt="Biryani" className="w-full h-full object-cover" /></div></Reveal>
          </div>
        </div>
      </section>

      <section className="py-24 bg-cream">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
          <Reveal className="text-center mb-14"><Overline className="justify-center">What Guides Us</Overline>
            <h2 className="font-serif text-burgundy text-4xl sm:text-5xl mt-4">Our promise on every plate.</h2></Reveal>
          <div className="grid md:grid-cols-3 gap-6">
            {[["Culinary Excellence", "Every recipe is refined until it earns its place on the menu."],
              ["Premium Hospitality", "Warm, well-coordinated service that anticipates your guests."],
              ["Professional Execution", "Planning, logistics and preparation handled end to end."]].map(([t, d], i) => (
              <Reveal key={t} delay={i * 0.1}><div className="bg-ivory border border-gold/20 rounded-2xl p-8 h-full">
                <div className="font-serif text-5xl gold-text mb-4">0{i + 1}</div>
                <h3 className="font-serif text-2xl text-burgundy mb-2">{t}</h3>
                <p className="text-charcoal/60 text-sm leading-relaxed">{d}</p>
              </div></Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-burgundy grain text-center">
        <div className="max-w-2xl mx-auto px-4">
          <h2 className="font-serif text-ivory text-4xl sm:text-5xl mb-6">Let's plan something memorable.</h2>
          <Link to="/quote-builder" className="btn-gold">Plan Your Event <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </section>
    </div>
  );
}
